var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 20,
  width: 20,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  focusable: "false"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
})));
export default SvgArrow;